class AppointmentTabsDatepicker extends TabsDatepicker {
    constructor(...args) {
        super(...args);
        this.preloader = new Preloader($(this.element).closest('.js-form'));
    }

    fetchTime(date) {
        this.preloader.showPreloader();
        const ajaxUrl = getAttr(this.element, 'data-ajax-url')
        return $.ajax({
            type: 'GET',
            data: { date: date, employee_id: this.employeeId },
            dataType: 'json',
            url: ajaxUrl
        });
    }

    get employeeId() {
        return $(this.element.closest('.js-employee-appointment-form'))
            .find('input[name="employee_id"]')
            .val();
    }
}

$('.js-appointment-tabs-datepicker').each((i, element) => {
    new AppointmentTabsDatepicker(element);
});
